import Dexie, { type Table } from 'dexie';
import type { Event, Service, GalleryItem, User } from './types';
import bcryptjs from 'bcryptjs';

export class ValentinaEventiDB extends Dexie {
  events!: Table<Event>;
  services!: Table<Service>;
  gallery!: Table<GalleryItem>;
  users!: Table<User>;

  constructor() {
    super('ValentinaEventiDB');
    this.version(1).stores({
      events: 'id, title, date, status, created_at, updated_at',
      services: 'id, title, created_at, updated_at',
      gallery: 'id, title, category, created_at, updated_at',
      users: 'id, email, created_at'
    });

    // Initialize admin user
    this.on('ready', async () => {
      const adminUser = await this.users.where('email').equals('admin@valentinaeventi.it').first();
      if (!adminUser) {
        const hashedPassword = await bcryptjs.hash('ValentinaEventi2024!', 10);
        await this.users.add({
          id: 'admin',
          email: 'admin@valentinaeventi.it',
          password: hashedPassword,
          created_at: new Date().toISOString()
        });
      }
    });
  }
}

const db = new ValentinaEventiDB();

export default db;